
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as scandMfBkYFj7R3Uw18TZJCtgp9HKSGFJzI9TmE2dY5bQQwMeta } from "/builds/WeArePublic/wap-app/pages/scan.vue?macro=true";
import { default as indexB5fjmCYr0XkitupCcURxmNwFNyrVIeE0lfwK7L919P4Meta } from "/builds/WeArePublic/wap-app/pages/index.vue?macro=true";
import { default as loginQMrtqayq4pZXqZD_I4bNGhuupir9_45_45x5Ip_457MFBEaesMeta } from "/builds/WeArePublic/wap-app/pages/login.vue?macro=true";
import { default as logoutyLpaffZnQCy7xPKpAkaRgb_45fjZYm_bPvy5yKQojJZa0Meta } from "/builds/WeArePublic/wap-app/pages/logout.vue?macro=true";
import { default as zoeken8rwadO98aWyJhGrvdnj2P3ei7n_45YzW23bLQFAuK4W6AMeta } from "/builds/WeArePublic/wap-app/pages/zoeken.vue?macro=true";
import { default as _91_46_46_46slug_930TOEdojLjbetAAeweR1DrxZwWFLsxaTZglBu0kzMfDEMeta } from "/builds/WeArePublic/wap-app/pages/[...slug].vue?macro=true";
import { default as indexoDEq51yC7MIXWNbwnuV4Ffx9q3X4r_IaTzlanfnY5RwMeta } from "/builds/WeArePublic/wap-app/pages/makers/index.vue?macro=true";
import { default as indexXRTsGtEQkKyCO_l_45O1uvMGK2M0umau_gvJ2PRd1bL60Meta } from "/builds/WeArePublic/wap-app/pages/venues/index.vue?macro=true";
import { default as _91slug_93h8xPOnMtwS4OZzYCcbYVdde9PPcNXWdgFUkQbpF1DQkMeta } from "/builds/WeArePublic/wap-app/pages/makers/[slug].vue?macro=true";
import { default as _91slug_930Ouyjc_45SLmsJdXJtwxHiF9ZD_45E1aiOEDynpV7fsg5dMMeta } from "/builds/WeArePublic/wap-app/pages/venues/[slug].vue?macro=true";
import { default as makerswOwG6Ol3spvOQrw_vPw7Sa97p_45EFEWcdhgP5WUBkHtgMeta } from "/builds/WeArePublic/wap-app/pages/profiel/makers.vue?macro=true";
import { default as venuesWas7MDCsJ_45tpF1RgZ_45ROhewcEHaOPzATaL_456jdwHPXIMeta } from "/builds/WeArePublic/wap-app/pages/profiel/venues.vue?macro=true";
import { default as _91slug_93RyXin81YBFplsxFEDLgtjmhg6Jxt1G6ZukpOCpOQ6BAMeta } from "/builds/WeArePublic/wap-app/pages/updates/[slug].vue?macro=true";
import { default as _91slug_93wV3L2H3Yh5D2zSWGg8FsI3EEWBHHliWgxg_jCr7kiKwMeta } from "/builds/WeArePublic/wap-app/pages/festival/[slug].vue?macro=true";
import { default as _91slug_93pscHq3Lrqe3WsZerMQpNFp9OD0Il1dSfPWWYxStjjWwMeta } from "/builds/WeArePublic/wap-app/pages/collectie/[slug].vue?macro=true";
import { default as gegevensLcmuZ6uMZUsNzqPANqrkWU1CMsfPSRGD9Pb7y1N8ig8Meta } from "/builds/WeArePublic/wap-app/pages/profiel/gegevens.vue?macro=true";
import { default as overzichtC4z_clOM5bJRkDwaANZSgKDfBmrPRhyjBCRO1UZ6wgsMeta } from "/builds/WeArePublic/wap-app/pages/profiel/overzicht.vue?macro=true";
import { default as abonnementw4iJVOCLwzXIteGIl3xLJ7_U79PkZPmEMDbb2KHZrOUMeta } from "/builds/WeArePublic/wap-app/pages/profiel/abonnement.vue?macro=true";
import { default as voorkeurennoyouVlbtDm2xmv0caI8rqF1mLR77vh9EBgDhPURhNUMeta } from "/builds/WeArePublic/wap-app/pages/profiel/voorkeuren.vue?macro=true";
import { default as beveiligingfJ_45QUIbjNpb1n1f_45MccyVEW4tQ5ZLZyLLXpPgdVoKw4Meta } from "/builds/WeArePublic/wap-app/pages/profiel/beveiliging.vue?macro=true";
import { default as _91slug_93YVDSGPsWxV5u4GJ0UcR_tzxxZJuzZgRAc2AZIMprXmIMeta } from "/builds/WeArePublic/wap-app/pages/productie-huis/[slug].vue?macro=true";
import { default as reserveringenk_s7iVg9qklS9FYGZv8TGqwhGj4ss_45_jrwHemnFwQFkMeta } from "/builds/WeArePublic/wap-app/pages/profiel/reserveringen.vue?macro=true";
import { default as _91id_93fxUR4HUYAJoObweFFzUpoU8yJFZRJIy4G3QRBGpe_45hUMeta } from "/builds/WeArePublic/wap-app/pages/programma/[slug]/[id].vue?macro=true";
import { default as indexAfeC9BzgUEtAUnlxiWIaZQtO7INmADkYe6gMIR3dN6oMeta } from "/builds/WeArePublic/wap-app/pages/programma/[slug]/index.vue?macro=true";
import { default as bezochte_45programmasbzMTU_45Pktu4W052Yvm6oVkcvganTs98GG_pM9rH2hMoMeta } from "/builds/WeArePublic/wap-app/pages/profiel/bezochte-programmas.vue?macro=true";
import { default as component_45stubDgrue7WGGkwRCwaFPrYuLz5ghV5sb3_45Or9HnGVsuVWcMeta } from "/builds/WeArePublic/wap-app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@types+node@22.20.5_@vue+compiler-sfc@3.5.13_ca_4dda6e840978e766d0ce94b2ef57e7b8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubDgrue7WGGkwRCwaFPrYuLz5ghV5sb3_45Or9HnGVsuVWc } from "/builds/WeArePublic/wap-app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@types+node@22.20.5_@vue+compiler-sfc@3.5.13_ca_4dda6e840978e766d0ce94b2ef57e7b8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "scan",
    path: "/scan",
    component: () => import("/builds/WeArePublic/wap-app/pages/scan.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/WeArePublic/wap-app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginQMrtqayq4pZXqZD_I4bNGhuupir9_45_45x5Ip_457MFBEaesMeta || {},
    component: () => import("/builds/WeArePublic/wap-app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutyLpaffZnQCy7xPKpAkaRgb_45fjZYm_bPvy5yKQojJZa0Meta || {},
    component: () => import("/builds/WeArePublic/wap-app/pages/logout.vue")
  },
  {
    name: "zoeken",
    path: "/zoeken",
    meta: zoeken8rwadO98aWyJhGrvdnj2P3ei7n_45YzW23bLQFAuK4W6AMeta || {},
    component: () => import("/builds/WeArePublic/wap-app/pages/zoeken.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/WeArePublic/wap-app/pages/[...slug].vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/builds/WeArePublic/wap-app/pages/makers/index.vue")
  },
  {
    name: "venues",
    path: "/venues",
    component: () => import("/builds/WeArePublic/wap-app/pages/venues/index.vue")
  },
  {
    name: "makers-slug",
    path: "/makers/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/makers/[slug].vue")
  },
  {
    name: "venues-slug",
    path: "/venues/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/venues/[slug].vue")
  },
  {
    name: "profiel-makers",
    path: "/profiel/makers",
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/makers.vue")
  },
  {
    name: "profiel-venues",
    path: "/profiel/venues",
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/venues.vue")
  },
  {
    name: "updates-slug",
    path: "/updates/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/updates/[slug].vue")
  },
  {
    name: "festival-slug",
    path: "/festival/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/festival/[slug].vue")
  },
  {
    name: "collectie-slug",
    path: "/collectie/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/collectie/[slug].vue")
  },
  {
    name: "profiel-gegevens",
    path: "/profiel/gegevens",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/gegevens.vue")
  },
  {
    name: "profiel-overzicht",
    path: "/profiel/overzicht",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/overzicht.vue")
  },
  {
    name: "profiel-abonnement",
    path: "/profiel/abonnement",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/abonnement.vue")
  },
  {
    name: "profiel-voorkeuren",
    path: "/profiel/voorkeuren",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/voorkeuren.vue")
  },
  {
    name: "profiel-beveiliging",
    path: "/profiel/beveiliging",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/beveiliging.vue")
  },
  {
    name: "productie-huis-slug",
    path: "/productie-huis/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/productie-huis/[slug].vue")
  },
  {
    name: "profiel-reserveringen",
    path: "/profiel/reserveringen",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/reserveringen.vue")
  },
  {
    name: "programma-slug-id",
    path: "/programma/:slug()/:id()",
    component: () => import("/builds/WeArePublic/wap-app/pages/programma/[slug]/[id].vue")
  },
  {
    name: "programma-slug",
    path: "/programma/:slug()",
    component: () => import("/builds/WeArePublic/wap-app/pages/programma/[slug]/index.vue")
  },
  {
    name: "profiel-bezochte-programmas",
    path: "/profiel/bezochte-programmas",
    meta: {"middleware":["auth"]},
    component: () => import("/builds/WeArePublic/wap-app/pages/profiel/bezochte-programmas.vue")
  },
  {
    name: component_45stubDgrue7WGGkwRCwaFPrYuLz5ghV5sb3_45Or9HnGVsuVWcMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubDgrue7WGGkwRCwaFPrYuLz5ghV5sb3_45Or9HnGVsuVWc
  }
]